import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Grid from '@mui/material/Grid2'
import InputAdornment from '@mui/material/InputAdornment'
import Typography from '@mui/material/Typography'

const CompetitionPaid = forwardRef(
  (
    {
      default_count_sportsmens = 1,
      default_type_paid = 1,
      default_sum_paid_1 = null,
      default_sum_paid_2 = null,
    },
    ref
  ) => {
    const [value_sum_paid_1, setValue_sum_paid_1] = React.useState(
      default_sum_paid_1 ? default_sum_paid_1 : ''
    )
    const [value_sum_paid_2, setValue_sum_paid_2] = React.useState(
      default_sum_paid_2 ? default_sum_paid_2 : ''
    )
    const count_sportsmens = [
      {
        value: 2,
        label: 'Два спортсмена',
        help: 'Рейтинговые и коммерческие соревнования.',
      },
      {
        value: 3,
        label: 'Два или три спортсмена',
        help: 'Только коммерческие соревнования.',
      },
    ]

    const type_paid = [
      {
        value: 1,
        label: 'Единый взнос с команды',
        help: 'Одинаковая сумма взносов для всех команд.',
      },
      {
        value: 2,
        label: 'В зависимости количества спортсменов',
        help: 'Сумма взноса зависит от количества спортсменов в команде.',
      },
    ]
    const [value_count_sportsmens, setValue_count_sportsmens] = React.useState(
      default_count_sportsmens
    )
    const [disabled, setDisabled] = React.useState(
      default_count_sportsmens == 2 ? true : false
    )
    const [value_type_paid, setValue_type_paid] =
      React.useState(default_type_paid)
    const [error, setError] = useState('')
    const val = () => {
      return {
        value_sum_paid_1,
        value_sum_paid_2,
        value_count_sportsmens,
        value_type_paid,
      }
    }
    const validate = () => {
      if (
        value_type_paid == 2 &&
        (value_sum_paid_2 == '' || value_sum_paid_1 == '')
      ) {
        setError(
          'Оба поля должны быть заполнены. Если это бесплатный турнир, поставьте 0.'
        )
        return false
      }

      if (value_type_paid == 1 && value_sum_paid_1 == '') {
        setError(
          'Это поле должно быть заполненно. Если это бесплатный турнир, поставьте 0.'
        )
        return false
      }
      setError('')
      return true
    }
    useImperativeHandle(ref, () => ({
      validate,
      val,
    }))
    const f__count_sportsmens = (e) => {
      setValue_count_sportsmens(e)
      if (e == 2) {
        setDisabled(true)
        setValue_type_paid(1)
      } else setDisabled(false)
    }
    return (
      <Grid container spacing={2} style={{ width: '100%' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            id="tournament_count_sportsmens"
            select
            label="Количество спортсменов"
            value={value_count_sportsmens}
            onChange={(e) => f__count_sportsmens(e.target.value)}
            style={{ width: '100%' }}
            variant="filled"
          >
            {count_sportsmens.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>{option.label}</span>
                  <span style={{ fontSize: '0.8em', color: 'gray' }}>
                    {option.help}
                  </span>
                </div>
              </MenuItem>
            ))}
          </TextField>

          <TextField
            id="tournament_type_paid"
            select
            label="Взнос с команды"
            value={value_type_paid}
            disabled={disabled}
            onChange={(e) => setValue_type_paid(e.target.value)}
            style={{ width: '100%' }}
            variant="filled"
            sx={{ mt: 2 }}
          >
            {type_paid.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span>{option.label}</span>
                  <span style={{ fontSize: '0.8em', color: 'gray' }}>
                    {option.help}
                  </span>
                </div>
              </MenuItem>
            ))}
          </TextField>
        </Grid>{' '}
        <Grid size={{ xs: 12, md: 6 }}>
          {value_type_paid == 1 ? (
            <>
              <Typography variant="body1" gutterBottom>
                Укажите взнос с команды. Взнос единый и не зависит от количества
                участников в команде. Он будет отображаться в регламенте турнира
                и на сайте приложения.{' '}
              </Typography>
              <TextField
                id="outlined-basic"
                label="Взнос с команды"
                type="number"
                variant="outlined"
                fullWidth
                error={!!error}
                onChange={(e) => setValue_sum_paid_1(e.target.value)}
                value={value_sum_paid_1}
                sx={{ mb: 1 }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">руб.</InputAdornment>
                    ),
                  },
                }}
              />
              {error && (
                <Grid item xs={12}>
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                </Grid>
              )}
            </>
          ) : (
            <>
              <Typography variant="body1" gutterBottom>
                Укажите взнос с команды из ДВУХ спорстменов.
              </Typography>
              <TextField
                id="outlined-basic"
                label="Взнос с команды из 2 спорстменов"
                type="number"
                variant="outlined"
                fullWidth
                error={!!error}
                onChange={(e) => setValue_sum_paid_1(e.target.value)}
                value={value_sum_paid_1}
                sx={{ mb: 1 }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">руб.</InputAdornment>
                    ),
                  },
                }}
              />
              <Typography variant="body1" gutterBottom>
                Укажите взнос с команды из ТРЁХ спорстменов.
              </Typography>
              <TextField
                id="outlined-basic"
                label="Взнос с команды из 3 спорстменов"
                type="number"
                variant="outlined"
                fullWidth
                error={!!error}
                onChange={(e) => setValue_sum_paid_2(e.target.value)}
                value={value_sum_paid_2}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">руб.</InputAdornment>
                    ),
                  },
                }}
              />
              {error && (
                <Grid item xs={12}>
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                </Grid>
              )}
              <Typography variant="body1" gutterBottom>
                Взнос будет отображаться в регламенте турнира и на сайте
                приложения.
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
    )
  }
)

export default CompetitionPaid
